<nav class="navbar navbar-default main-footer fixed-bottom navbar-nc">
  <div class="container-fluid">
    <div class="row">
      <div id="footer_text" class="col-xs-12 col-sm-12">
        <div *ngIf="showWarningText">
          <h5 class="govWarningText">
            <strong>WARNING WARNING WARNING</strong>
          </h5>
          <div class="govWarningText">
            You have accessed a U.S. Government information system, which
            includes (1) this computer, (2) this network, (3) all computers
            connected to this network, and (4) all devices and storage media
            attached to this network or to a computer on this network. U.S.
            Government information systems are provided for the processing of
            official U.S. Government information only. Unauthorized or improper
            use of this information system is prohibited and may subject you to
            disciplinary action, as well as civil and criminal penalties. All
            data contained on U.S. Government information systems is owned by
            the U.S. Government and may, for the purpose of protecting the
            rights and property of the U.S. Government, be monitored,
            intercepted, recorded, read, searched, copied, or captured in any
            manner and disclosed or used for any lawful government purpose at
            any time. THERE IS NO RIGHT TO PRIVACY IN THIS SYSTEM. System
            personnel may give to law enforcement officials any potential
            evidence of crime found on U.S. Government information systems. USE
            OF THIS SYSTEM BY ANY USER, AUTHORIZED OR UNAUTHORIZED, CONSTITUTES
            YOUR UNDERSTANDING AND CONSENT TO THIS MONITORING, INTERCEPTION,
            RECORDING, READING, COPYING, OR CAPTURING AND DISCLOSURE.
          </div>
        </div>
        <button class="btn loginScreenLinks" routerLink="/contact">
          Contact
        </button>
        |
        <button class="btn loginScreenLinks" routerLink="/help">Help</button> |
        <button class="btn loginScreenLinks" routerLink="/privacyPolicy">
          Privacy
        </button>
        <span *ngIf="!hideHomeLink">|</span>
        <button
          class="btn loginScreenLinks"
          *ngIf="!hideHomeLink"
          routerLink=""
        >
          Home
        </button>
        <div class="loginScreenLinks float-right" style="padding-top:10px; display: inline-block">
          <app-copy-right></app-copy-right>
        </div>
      </div>
    </div>
  </div>
</nav>
